import { api } from '@services';
import CustomField, {
  ICustomField,
  ICustomFieldApiModel,
} from '@models/CustomField.model';

interface IRequest {
  data: IIndexUniqueFields;
}

interface IIndexUniqueFields {
  isUnique: boolean;
}

const indexUniqueFields = async ({
  data,
}: IRequest): Promise<ICustomField[]> => {
  const { data: uniqueCustomFields } = await api.get<ICustomFieldApiModel[]>(
    `/customFields?isUnique=${data.isUnique}`,
  );

  return CustomField.arrayFromApiModel(uniqueCustomFields);
};

export { indexUniqueFields };
